import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';
import { ReactElement, useId, useState } from 'react';
import React from 'react';

const ComponentPreview = () => {
  const [checkboxId] = useState(
    () =>
      // useId hook not working for some reason.
      'id' + Math.random().toString(16).substring(2),
  );
  const [mini, setMini] = useState(false);
  const [rebrandDm2025, setRebrandDm2025] = useState(true);
  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Button</h3>
        <p>
          These are design system buttons. They do not currently fill their
          container. Their vertical height may change depending on the container
          that they appear in, which then makes the button text appear
          non-centered.
        </p>
        <p>
          <input
            id={checkboxId + '2'}
            type="checkbox"
            onClick={(e) => setRebrandDm2025(e.currentTarget.checked)}
            defaultChecked={rebrandDm2025}
          />
          <label htmlFor={checkboxId + '2'}>Rebrand DM2025</label>
          {' \u2007 '}
          <input
            id={checkboxId}
            type="checkbox"
            onClick={(e) => setMini(e.currentTarget.checked)}
          />
          <label htmlFor={checkboxId}>Mini button</label>
        </p>
        <div style={{ maxWidth: 300, marginTop: 16 }}>
          <RoundedButton rebrandDm2025={rebrandDm2025} mini={mini}>
            Button text
          </RoundedButton>{' '}
          <br />
          <br />
          <RoundedButton rebrandDm2025={rebrandDm2025} secondary mini={mini}>
            Button text
          </RoundedButton>
          <br />
          <br />
          <ButtonPreviewErrorBoundary dependencies={[mini]}>
            <RoundedButton rebrandDm2025={rebrandDm2025} loading mini={mini}>
              Button text
            </RoundedButton>
          </ButtonPreviewErrorBoundary>
          <br />
          <br />
          <RoundedButton rebrandDm2025={rebrandDm2025} disabled mini={mini}>
            Button text
          </RoundedButton>
          <br />
          <br />
          <RoundedButton
            rebrandDm2025={rebrandDm2025}
            colorStyle={ColorStyle.Iceland}
            mini={mini}
          >
            Button text
          </RoundedButton>
          <br />
          <br />
          <RoundedButton
            rebrandDm2025={rebrandDm2025}
            colorStyle={ColorStyle.Gray}
            mini={mini}
          >
            Button text
          </RoundedButton>
          <br />
          <br />
          <RoundedButton
            rebrandDm2025={rebrandDm2025}
            colorStyle={ColorStyle.OutlineDark}
            mini={mini}
          >
            Button text
          </RoundedButton>
        </div>
        <p>
          This is how buttons behave in a flex container. A secondary button has
          a border, but a primary button does not. This causes the button text
          to be centered incorrectly. Additionally, the background colour is set
          via inline styles, but there is also a hover colour. This makes adding
          a border to match the heights tricky. The component should be
          rewritten to just use CSS and no inline-styles.
        </p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 24,
          }}
        >
          <RoundedButton rebrandDm2025={rebrandDm2025} mini={mini}>
            Button text
          </RoundedButton>
          <RoundedButton rebrandDm2025={rebrandDm2025} mini={mini} secondary>
            Button text
          </RoundedButton>
          <ButtonPreviewErrorBoundary dependencies={[mini]}>
            <RoundedButton rebrandDm2025={rebrandDm2025} mini={mini} loading>
              Button text
            </RoundedButton>
          </ButtonPreviewErrorBoundary>
          <RoundedButton rebrandDm2025={rebrandDm2025} mini={mini} disabled>
            Button text
          </RoundedButton>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

class ButtonPreviewErrorBoundary extends React.Component<
  { children: ReactElement; dependencies: unknown[] },
  { error?: Error | undefined }
> {
  constructor(props: { children: ReactElement; dependencies: unknown[] }) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Optional: log error to a service
    console.error('ErrorBoundary caught an error:', error, info);
  }

  componentDidUpdate(prevProps: {
    children: ReactElement;
    dependencies: unknown[];
  }) {
    for (let i = 0; i < this.props.dependencies.length; i++) {
      if (this.props.dependencies[i] !== prevProps.dependencies[i]) {
        this.setState({ error: undefined });
      }
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ color: 'red', height: 40, position: 'relative' }}>
          <div style={{ position: 'absolute', whiteSpace: 'nowrap' }}>
            {this.state.error?.message}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Button',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
